import __vue_component__ from './TooltipContent.vue.js';

//
var script = {
  name: 'Tooltip',
  components: {
    TooltipContent: __vue_component__
  },
  props: {
    label: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    offset: {
      type: String,
      default: '0,5'
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    boundariesElement: {
      type: String,
      default: 'viewport'
    }
  },

  data() {
    return {
      show: false
    };
  },

  methods: {
    onMouseEnter() {
      if (this.disabled) {
        return;
      }

      this.show = true;

      if (this.appendToBody) {
        this.$nextTick(() => {
          this.append();
        });
      }
    },

    onMouseLeave() {
      if (this.appendToBody) {
        if (this.$refs.popper) {
          document.body.removeChild(this.$refs.popper.$el);
        }
      }

      this.show = false;
    },

    append() {
      if (this.$refs.popper) {
        document.body.appendChild(this.$refs.popper.$el);
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tooltip/Tooltip.vue_rollup-plugin-vue=script.js